const AB = window.AB || {};

(function() {
  const SESSION_STORAGE_PROPERTY_KEY = 'ab_discount_variant';
  const ITEM_PROPERTY_KEY = '_discountItem';
  let cart = null;
  let discountArr = null;

  const bannerHTML = document.querySelector('.ab_banner_image').innerHTML;
  const bannerContainer = document.querySelector('.ab_banners');
  if(bannerContainer){
    bannerContainer.innerHTML = bannerHTML;
  }


  const hideBanners = () => {
    if(!bannerContainer){
      return;
    }
    bannerContainer.classList.add('ab_hidden')
  }
  const showBanners = () => {
    if(!bannerContainer){
      return;
    }
    bannerContainer.classList.remove('ab_hidden');

  }

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const findGiftLineItemById = (id) => cart?.items.find(p => {
    return p.product_id === id && p?.properties[ITEM_PROPERTY_KEY]
  });

  const refreshCart = async() => {
    const newCart = await fetch('/cart.js')
        .then(response => response.json())
        .then(data => { return data });

    cart = newCart;
    BOLD.common.eventEmitter.emit('AB_Discount_finished', newCart);
  }

  const removeFromCart = async (variantKey) => {
    await fetch(`/cart/change.js`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'id': variantKey,
        'quantity': 0
      })
    });
  }

  const addToCart = async(variantId, sessionVariantId) => {
    const resp = await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: sessionVariantId || variantId,
            properties: {
              [ITEM_PROPERTY_KEY]: true
            }
          }
        ]
      })
    });

    if(resp.status === 422) {
      if (sessionVariantId) {
        sessionStorage.removeItem(SESSION_STORAGE_PROPERTY_KEY)
      }
      console.error("Could not add variant, defaulting to available one");
    }
    return resp.ok;
  }


  AB.applyDiscounts = async () => {
    await refreshCart();

    const cartTotal = cart.items.filter(i => !i?.properties[ITEM_PROPERTY_KEY]).reduce((acc, cur) => {
      acc += cur.line_price;
      return acc;
    }, 0);


    for(let i=0; i < discountArr.length; i++){
      const discount = discountArr[i];
      const discountProduct = discount.discount;
      const giftItem = findGiftLineItemById(discountProduct.id);
      const isGiftItemInCart = giftItem !== undefined;
      const availableVariant = discountProduct.variants.find(v => v.available);


      BOLD.common.eventEmitter.on('ab_update_cart_variant', async function(data) {
        const variantId = parseInt(data?.variantId);
        const variant = discountProduct.variants.find(v => v.id === variantId);
        if(!variant){
          return;
        }

        const newVariant = discountProduct.variants.find(v => v.options.join(',') === data.optionKey);

        if(variant.id === newVariant.id) {
          return;
        }

        sessionStorage.setItem(SESSION_STORAGE_PROPERTY_KEY, JSON.stringify(newVariant))
        await removeFromCart(data.variantKey)

        const isAddToCartSuccess = await addToCart(newVariant.id);
        if(!isAddToCartSuccess) {
          await sleep(500);
          await addToCart(availableVariant.id);
        }

        await refreshCart();
      });

      if((cartTotal < discount.threshold) && isGiftItemInCart){
        await removeFromCart(giftItem.key)
        continue;
      }

      if(cartTotal < discount.threshold){
        continue;
      }

      if(isGiftItemInCart) {
        continue;
      }

      let sessionVariantId = null;
      if(sessionStorage.getItem(SESSION_STORAGE_PROPERTY_KEY)){
        const previousVariant = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_PROPERTY_KEY));
        sessionVariantId = previousVariant.id;
      }


      const isAddToCartSuccess = await addToCart(availableVariant.id, sessionVariantId);
      if(!isAddToCartSuccess){
        await sleep(500);
        await addToCart(availableVariant.id);
      }
    }

    await refreshCart();

    const isAGiftItemInCart = cart.items.find(p => p?.properties[ITEM_PROPERTY_KEY])

    if(isAGiftItemInCart){
      showBanners();
    }
    else {
      hideBanners();
    }

  }

  AB.setCart = (c) => {
    cart = c;
  }

  AB.setDiscounts = (d) => {
    discountArr = d;
  }

  BOLD.common.eventEmitter.on('AB_Discount_update', AB.applyDiscounts);
  BOLD.common.eventEmitter.on('AB_cart_updated', function(newCart){
    cart = newCart
  });

})();
